import { AcornsIcon } from '@acorns/icons'
import { theme } from '@acorns/web-components'
import styled from 'styled-components'

import { RECAP_MEDIUM_BREAKPOINT, RECAP_XS_BREAKPOINT, fonts } from '../styles'

export const Container = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  max-height: 728px;
  padding: 120px 0;
  position: relative;
  width: 100%;

  @media screen and (max-width: ${RECAP_MEDIUM_BREAKPOINT - 1}px) {
    max-height: initial;
    height: 100%;
    padding: 100px 0;
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    height: 100%;
    padding: 30px 0 80px;
  }
`

export const PaddingWrapper = styled.div`
  padding: 0 70px;

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    padding: 0 50px;
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    padding: 0 30px;
  }
`

export const Title = styled.h2`
  color: ${theme.colors.white};
  font-family: 'Avenir Next';
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 38px;
  margin-bottom: 50px;
  text-align: center;

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    max-width: 400px;
  }

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    text-align: left;
  }
`

export const GrowLeafContainer = styled.div`
  border-radius: ${theme.borderRadius.large};
  border: 1px solid #ffffff1a;
  box-sizing: content-box;
  margin-top: 62px;
  max-width: 520px;
  padding: 20px;
  position: relative;

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    max-width: 400px;
  }
`

export const GrowLeafIconWrapper = styled.div`
  background-color: ${theme.colors.charcoal};
  position: absolute;
  width: 24px;
  height: 24px;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 0;
`

export const GrowLeafIcon = styled(AcornsIcon)`
  position: relative;
  top: -1px;

  path {
    &[fill] {
      fill: ${theme.colors.white};
    }
  }
`

export const GrowLeafText = styled.p`
  ${fonts.AN_14_600_22}
  color: ${theme.colors.stoneLight};
  letter-spacing: 0px;
  margin: 0;
  text-align: center;
`
